import React from 'react';
import { pick } from 'ramda';
import { useLocation } from 'react-router-dom';
import { useAppSelector } from 'js/store/hooks';
import { Link } from '@core/js/components/common/Link';

import style from './Logo.scss';

export const Logo: React.FC = () => {
    const { customization: { siteLogoPath = '' } = {}, requestStamp, themeName } = useAppSelector(pick([
        'customization', 'requestStamp', 'themeName'
    ]));
    const { search } = useLocation();
    const searchParams = new URLSearchParams(search);
    const casinoname = searchParams.get('casinoname');
    const site = searchParams.get('site');
    const params = new URLSearchParams({
        t: `${requestStamp}`,
        ...casinoname && { casinoname },
        ...site && { site }
    });
    const logoURL = siteLogoPath
        ? `${siteLogoPath}?${params.toString()}`
        : `/${themeName}/images/logo.png?${params.toString()}`;

    return (
        <div className={style.logo}>
            <Link href="/">
                <img className={style.logoImage} src={logoURL} alt="logo" />
            </Link>
        </div>
    );
};
